import { gql } from 'apollo-angular';

export var nav_search_projects = gql`
  query navSearchProjects(
    $searchLike: String!
    $search: String!
    $limit: Int!
    $page: Int
  ) {
    search_projects(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      page: $page
    ) {
      data {
        id
        name
        projectStatuses {
          active
          is_primary
          status_sequence_id
        }
        participants(
          hasRole: { column: NAME, operator: EQ, value: "Developer" }
        ) {
          organization {
            name
          }
          person {
            name
          }
        }
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;
